module.exports = "/img/google_plus.png?03c95edb7f9655b99ae5dec115e9fa05";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/google_plus.png
// module id = wCsn
// module chunks = 70